import React from 'react';
import Icon from '../Icon';

interface IProps {
  cards: string[];
  containerClassName?: string;
  cardClassName?: string;
}
const CardRowVSE = ({ cards, containerClassName, cardClassName }:IProps) => (
  <div className={containerClassName ?? 'flex gap-2'}>
    {cards.map((cardSrc, index) => <React.Fragment key={`card-${cardSrc}`}><Icon iconKey={`${index}`} src={cardSrc} className={cardClassName ?? 'w-[48px] h-[56px]'} iconId={`${cardSrc}-${index}`} /></React.Fragment>)}
  </div>
);

export default CardRowVSE;
